export enum PartnerTabs {
    Home = 'home',
    Dashboard = 'dashboard',
    Visitors = 'visitors'
}